import { createTheme } from '@material-ui/core/styles';

const basicTheme = createTheme({
    typography: {
        button: {
            textTransform: 'none',
        },
        fontFamily: 'AudiTypeVar-Normal, Verdana, sans-serif !important',
    },

    palette: {
        primary: {
            main: '#1C1C1C',
            contrastText: '#fff',
        },

        secondary: {
            main: '#333333',
            contrastText: '#fff',
        },
    },
});

export default basicTheme;
